import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchPaymentConfigSuccess,
  fetchPaymentConfigFailure,
  fetchPaystackConfig,
  fetchRemitaConfig,
  fetchInterswitchConfig,
  fetchNabrollConfig
} from '../actions';
import paymentConfigTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* fetchAllPaymentConfig() {
  const url = `${API_BASE_URL}/paylog-configurations`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    let remita = '';
    let paystack = '';
    let interswitch = '';
    let nabroll = ''
    if (response.raw.length > 0) {
      response.raw.forEach((config) => {
        if (config.paymentPlatform === 'REMITA') {
          remita = config.id;
        } else if (config.paymentPlatform === 'PAYSTACK') {
          paystack = config.id;
        } else if (config.paymentPlatform === 'INTERSWITCH') {
          interswitch = config.id;
        } else if (config.paymentPlatform === 'NABROLL') {
          nabroll = config.id;
        }
      });
      if (remita) {
        yield put(fetchRemitaConfig(remita));
      }
      if (paystack) {
        yield put(fetchPaystackConfig(paystack));
      }
      if (interswitch) {
        yield put(fetchInterswitchConfig(interswitch));
      }
    } 
     if (nabroll) {
      yield put(fetchNabrollConfig(nabroll));
    }

    yield put(fetchPaymentConfigSuccess(response.raw));
  } else {
    yield put(
      fetchPaymentConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* getAllPaymentConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYMENT_CONFIG_REQUEST,
    fetchAllPaymentConfig
  );
}
